import { LoadManager, PageHeader, Styles } from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import dateMask from '@/lib/masks/date'
import mistreatmentTypes from '@/services/api/mistreatmentTypes'
import React from 'react'
import { useParams } from 'react-router-dom'
import SelectAssunto from './SelectAssunto'

function OsmIntegration({ title }) {
  usePageTitle({ title })
  const { id } = useParams()

  const {
 loading, error, data, setData,
} = useAxiosRequest(mistreatmentTypes.show, id)

  const assunto = data?.assunto

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Integração com OS-m"
        subtitle="Configure a integração com o OS-m"
        icon="fas fa-cogs"
      />

      <LoadManager loading={loading} error={error} data={data}>
        {
          Boolean(data) && (
            <div className="p-2 s-rounded bg-gray">
              <div className="h4">{data?.title}</div>
              <div>{data?.description}</div>
              <div className="mt-2">
                <small>
                  <div>Data de criação: {dateMask(data?.createdAt)}</div>
                  <div>Data de atualização: {dateMask(data?.updatedAt)}</div>
                </small>
              </div>
              <div className="divider my-2" />
              <div>Assunto da integração</div>
              <SelectAssunto typeId={id} assunto={assunto} onAssuntoChanged={setData} />
            </div>
          )
        }
      </LoadManager>
    </Styles.Container>
  )
}

export default OsmIntegration
